import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { environment } from 'src/environments/environment';

/**
 * Route guard for the admin Editorial Intelligence workspace.
 *
 * The editorial workspace is a Dev2-only proof of concept. Production builds set
 * environment.editorialEnabled = false, so any attempt to reach an editorial
 * route (directly or via a bookmarked/typed URL) is redirected to the landing
 * page. Dev builds set the flag true and behave exactly as before.
 *
 * This only gates navigation — it does not touch backend, Media Centre logic,
 * or the dev environment wiring.
 */
@Injectable({ providedIn: 'root' })
export class EditorialEnabledGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    return environment.editorialEnabled ? true : this.router.parseUrl('/landing');
  }
}
